import { Outlet } from "react-router-dom";
import UserRegistrationNavbar from "../UserRegistrationNavbar/UserRegistrationNavbar";
import noLandscape from "../../../assets/svg/rotate-portrait.svg";
import { Text } from "@jds/core";
import { useEffect } from "react";
import { setSelfieModalClose } from "../../../store/state-slices/userRegistration";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";

const UserRegistrationLayout = () => {
  const dispatch = useDispatch();

  const rootLayout = document.getElementById("root-layout");
  useEffect(() => {
    if (rootLayout) {
      rootLayout.style.height = "unset";
    }
  });

  function detectLandscapeMode(callback) {
    function checkOrientation() {
      if (window.innerWidth > window.innerHeight) {
        callback("Landscape mode detected");
      }
    }
    checkOrientation();
    window.addEventListener("orientationchange", checkOrientation);
    window.addEventListener("resize", checkOrientation);
  }

  detectLandscapeMode(function (message) {
    dispatch(setSelfieModalClose(true));
  });
  return (
    <>
      <Box
        sx={{
          display: { xs: "none", sm: "none" },
          // width: "100vw",
          // height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          "@media screen and (max-width: 991px) and (min-aspect-ratio: 13/9)": {
            display: "flex",
            paddingTop: "13%",
            zIndex: 2147483647,
          },
        }}
      >
        <Box
          sx={{
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Box
            component="img"
            src={noLandscape} // your rotation image
            alt="Please rotate your device"
            sx={{
              width: "15%",
              height: "15%",
            }}
          />

          <Text
            text="Rotate your device to portrait mode for a better viewing experience of JioAICloud."
            textAlign="center"
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "block",
          "@media screen and (max-width: 991px) and (min-aspect-ratio: 13/9)": {
            display: "none",
          },
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};
export default UserRegistrationLayout;
